import request from '@/utils/request'

export const BASE_URL = 'system/role'

export const PAGE_URL = `${BASE_URL}/page`

export function listAll() {
  return request({
    url: `${BASE_URL}/all`,
    method: 'get'
  })
}

export function page(query: any) {
  return request({
    url: `${BASE_URL}/page`,
    method: 'get',
    params: query
  })
}

export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

export function get(id: any) {
  return request({
    url: `${BASE_URL}/${id}`,
    method: 'get'
  })
}

export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}

export function getRoleAuth(roleId: any) {
  return request({
    url: `${BASE_URL}/auth`,
    method: 'get',
    params: {
      roleId: roleId
    }
  })
}

export function auth(auth: any) {
  return request({
    url: `${BASE_URL}/auth`,
    method: 'post',
    data: auth
  })
}

